import { ExportAllListActions } from '../ExportAllButton';
import React from 'react';
import {
  ListGuesser,
  ShowGuesser,
  CreateGuesser,
  FieldGuesser,
  InputGuesser,
  EditGuesser,
} from '@api-platform/admin';
import { Grid } from '@mui/material';
import {
  ReferenceArrayField,
  ReferenceField,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  SingleFieldList,
  TextField,
  ChipField,
  ReferenceArrayInput,
  DateField,
  useRecordContext,
} from 'react-admin';
import { AddressInputs } from '../Inputs/AddressInputs';
import { getSelectedCompanyFilter } from '../../helper/filter';

export const CityList = (props) => {
  const companyFilter = getSelectedCompanyFilter();
  return (
    <ListGuesser actions={<ExportAllListActions />} {...props} filter={companyFilter}>
      <FieldGuesser source={'name'} />
      <ReferenceField label="Company" source="company" reference="companies">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="CreatedBy" source="createdBy" reference="users">
        <TextField source="email" />
      </ReferenceField>
      <DateField source={'updatedAt'} locales={'de'} showTime />
      <DateField source={'createdAt'} locales={'de'} showTime />
    </ListGuesser>
  );
};

export const CityShow = (props) => (
  <ShowGuesser {...props}>
    <FieldGuesser source={'name'} />
    <FieldGuesser source={'drupalId'} />
    <FieldGuesser source={'oldId'} />
    <FieldGuesser source={'code'} />
    <FieldGuesser source={'msBookingsUrl'} />
    <ReferenceArrayField label="Users" reference="users" source="users">
      <SingleFieldList>
        <ChipField source="email" />
      </SingleFieldList>
    </ReferenceArrayField>
    <ReferenceField
      label="Inquiry Contact Person"
      source="inquiryContactPerson"
      reference="users"
    >
      <TextField source="email" />
    </ReferenceField>
    <ReferenceField
      label="Review Contact Person"
      source="reviewContactPerson"
      reference="users"
    >
      <TextField source="email" />
    </ReferenceField>
    <FieldGuesser source={'createdAt'} />
    <FieldGuesser source={'updatedAt'} />
    <ReferenceField label="CreatedBy" source="createdBy" reference="users">
      <TextField source="email" />
    </ReferenceField>
    <ReferenceField label="UpdatedBy" source="updatedBy" reference="users">
      <TextField source="email" />
    </ReferenceField>
  </ShowGuesser>
);

export const CityCreate = (props) => {
  const companyFilter = getSelectedCompanyFilter();
  return (
    <CreateGuesser {...props}>
      <Grid container spacing={4} sx={{ p: 2 }}>
        <Grid item xs={4}>
          <ReferenceInput
            source="company"
            reference="companies"
            label="Company"
            filterToQuery={(searchText) => ({ name: searchText })}
          >
            <SelectInput
              fullWidth
              source="company"
              optionText="name"
              disabled={true}
              defaultValue={companyFilter.company}
            />
          </ReferenceInput>
          <InputGuesser fullWidth source={'name'} />
          <InputGuesser fullWidth source={'code'} />
          <InputGuesser fullWidth source={'msBookingsUrl'} />
        </Grid>
        <Grid item xs={4}>
          <AddressInputs />
        </Grid>
      </Grid>
    </CreateGuesser>
  );
};

export const CityEdit = (props) => (
  <EditGuesser {...props}>
    <CityEditInputs />
  </EditGuesser>
);

export const CityEditInputs = (props) => {
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  console.log(record);

  return (
    <Grid container spacing={4} sx={{ p: 2 }}>
      <Grid item xs={4}>
        <InputGuesser fullWidth source={'name'} />
        <InputGuesser fullWidth source={'msBookingsUrl'} />
        <ReferenceArrayInput
          fullWidth
          source="users"
          reference="users"
          label="Users"
          filter={{
            'companies[]': record.company,
          }}
        >
          <SelectArrayInput
            fullWidth
            source="users"
            optionText="email"
            optionValue={'@id'}
          />
        </ReferenceArrayInput>
        <ReferenceInput
          fullWidth
          source="inquiryContactPerson"
          reference="users"
          filter={{
            'cities[]': record.id,
          }}
        >
          <SelectInput
            fullWidth
            source="users"
            optionText="email"
            optionValue={'@id'}
          />
        </ReferenceInput>
        <ReferenceInput
          fullWidth
          source="reviewContactPerson"
          reference="users"
          filter={{
            'cities[]': record.id,
          }}
        >
          <SelectInput
            fullWidth
            source="users"
            optionText="email"
            optionValue={'@id'}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={4}>
        <AddressInputs />
      </Grid>
    </Grid>
  );
};
